import {Menu} from "@mantine/core";
import classes from "./Icon.module.css";
import {cloneElement, ReactElement, ReactNode} from "react";

type Props = {
    icon: ReactNode;
    children: ReactNode | ReactNode[];
};

/**
 * Renders icon from props icon, and Menu.Items and Dividers from props.children.
 * @author Kacper Faber
 * @since 0.1.9
 */
function MenuIcon(props: Props) {
    return (
        <Menu>
            <Menu.Target>
                <div className={classes.root}>
                    {cloneElement(props.icon as ReactElement, {size: 17})}
                </div>
            </Menu.Target>

            <Menu.Dropdown>
                { props.children }
            </Menu.Dropdown>
        </Menu>
    );
}

export default MenuIcon;